(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WYSIWYG", [], factory);
	else if(typeof exports === 'object')
		exports["WYSIWYG"] = factory();
	else
		root["WYSIWYG"] = factory();
})(this, function() {
return 